import Reel from "./Reel";
import Cell from "./Cell";
import Utils from "../../utils/Utils";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";

export default class ReelDynamic extends Reel {

    private reelPath: Phaser.Curves.Path;
    private reelStartY = ResourcesDispatcher.GAME_CONSTANTS.FREE_SPIN_REEL_START_Y;
    
    constructor(scene: any, x: number, y: number, index: number, cellCreation: { cells: Cell[]; cellPositions: any[] }, expanding: Cell | null) {
        super(scene, x, y, index, cellCreation, expanding);

        this.reelPath = this.createReelPath();
        
        // this.cells.forEach(c => {
        //     this.bendReelRun(c);
        // });

        // for(let i=0; i<3; i++){
        //     const ew = CreationManager.createExpandingWild(this.scene, this.cellPosition, i+1, i, layoutBuilder);
        //     this.extraWilds.push(ew)
        //     this.container.add(ew.getContainer())
        // }
        
        // this.debugDrawPath();
    }

    private createReelPath(): Phaser.Curves.Path {

        let lastCellCoordinates = this.layoutBuilder.getNodeByPath(`Basegame/grid/reel_${this.index}/cell_0`);
        // console.log("Last cell coordinates:", lastCellCoordinates); // Debug: verifica le coordinate dell'ultima cella
        
        // Utils.createDebugGraphics(this.scene,
        //     lastCellCoordinates?.coordinates.relative_top_left_to_parent?.x  || 0,
        //     lastCellCoordinates?.coordinates.relative_top_left_to_parent?.y  || 0,
        //     200, 200, 0xff0000, 0.5, { x: 0.5, y: 0.5 }, this.container);


        const start = (lastCellCoordinates?.coordinates.relative_top_left_to_parent?.x  || 0);

        const path = new Phaser.Curves.Path(start, this.reelStartY);

        //  create a vector of point based on the cells coordinates
        let cellCoordinates = Object.assign([], this.cellPosition);
        cellCoordinates.reverse();

        const points = [];
        for(let i=0; i<this.numOfCellsPerReel + this.numOfExtraCellsPerReel; i++){
            points.push(new Phaser.Math.Vector2(
                cellCoordinates[i].x,
                cellCoordinates[i].y
            ))
        }

        path.splineTo(points);

        return path;
    }

    public bendReelRun(cell: Cell): void {

        let lastCellCoordinates = this.layoutBuilder.getNodeByPath(`Basegame/grid/reel_${this.index}/cell_0`);
        // console.log("Last cell coordinates:", lastCellCoordinates); // Debug: verifica le coordinate dell'ultima cella
        const END_Y = (lastCellCoordinates?.phaser?.display?.y  || 0) + (lastCellCoordinates?.phaser?.geom?.height || 0);


        const index = cell.getIndex();

        // ✅ Usa la posizione Y ORIGINALE (mantiene l'ordine corretto degli indici!)
        const originalY = this.cellPosition[index].y + this.spinProgressValue.value;
        
        // ✅ Normalizza Y usando la posizione originale (non centrata!)
        const t = Phaser.Math.Clamp((originalY - this.reelStartY) / END_Y, 0, 1);

        const point = this.reelPath.getPoint(t);

        cell.getContainer().setPosition(point.x, point.y);
    }

    private debugDrawPath(): void {
        const graphics = this.scene.add.graphics();
        const colors = [0x0000ff, 0x0000ff, 0x0000ff, 0x0000ff, 0x0000ff];
        
        graphics.lineStyle(20, colors[this.index], 1);
        this.reelPath.draw(graphics, 128);
        this.container.add(graphics);
    }

    public configureSpinTween() {
        this.resetFlagsAndCounters();
        
        this.spinProgress = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height},
            paused: true,
            loop: -1,
            delay: 0,
            yoyo: false,
            duration: this.spinAnimationDuration,
            onStart: () => {
                // this.expandingWild.getContainer().setVisible(false);

                this.getCells().forEach(cell => {
                    cell.resetLayer();
                    cell.stopAnimation();
                });

                this.turnOn();
            },
            onUpdate: () => {
                if (this.stopped) {
                    return;
                }

                this.getCells().forEach(cell => {
                    this.bendReelRun(cell);

                    // ON/OFF depending on memo if suspense is on
                    if (this.suspense && this.suspenseStarted) {
                        if (Utils.includes(ResourcesDispatcher.GAME_CONSTANTS.onDuringSuspense, cell.getMemo())) {
                            cell.turnOn();
                        } else {
                            cell.turnOff();
                        }
                    }
                });
                
            },
            onLoop: () => {
                if (this.stopped) {
                    return;
                }

                this.virtualReelPosition = (this.virtualReelPosition + 1) % this.scene.gameArea.virtualGrid[this.index].length;
                this.scene.gameArea.increaseLoopCounter(this.index);

                this.reIndexCells();
                if (this.mustStop) {

                    this.getCell(0).setCellInfo(this.gameDataManager.getOutGridCellsUp()[this.index]);
                    this.getCell(this.lastCellIndex).setCellInfo(this.gameDataManager.getOutGridCellsDown()[this.index]);

                    // Real memo
                    for (let i = 1; i < this.lastCellIndex; i++) {
                        const realmemo = this.gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (i - 1)];
                        let gridListIndex = Utils.getCellGridIndex(this.index, i, this.numOfCellsPerReel, this.numOfExtraCellsPerReel);
                        this.getCell(i).setCellInfo(realmemo, undefined, gridListIndex ? this.gameDataManager.getLinkGrid()[gridListIndex] : undefined);
                    }

                    this.spinProgress.stop();
                    this.bounce();

                } else if (!this.canStop) { // Fake memo
                    const xmemo = this.scene.gameArea.virtualGrid[this.index][this.virtualReelPosition];
                    this.getCell(this.lastCellIndex).setCellInfo(xmemo);

                } else if (this.canStop) {
                    if (this.realMemoIndex === 0) { // Invisible cell
                        this.getCell(this.lastCellIndex).setCellInfo(this.gameDataManager.getOutGridCellsDown()[this.index]);
                    } else if (this.realMemoIndex < this.lastCellIndex) { // Visible cell, real memo
                        const realmemo = this.gameDataManager.getGrid()[this.index * this.numOfCellsPerReel + (this.realMemoIndex - 1)];
                        this.getCell(this.lastCellIndex).setCellInfo(realmemo, undefined, this.gameDataManager.getLinkGrid()[this.index * this.numOfCellsPerReel + (this.realMemoIndex - 1)] ?? undefined);
                    } else if (this.realMemoIndex === this.lastCellIndex) { // Invisible cell, fake memo with SCATTER and WILD check, stop spin
                        this.getCell(this.lastCellIndex).setCellInfo(this.gameDataManager.getOutGridCellsUp()[this.index]);
                        this.spinProgress.stop();
                        this.bounce();
                    }
                    this.realMemoIndex++;
                }
            }
        });
    }

    public bounce() {
        if (this.stopped) {
            return;
        }

        this.bounceTween1 = this.scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: this.cellSize.height * 0.75 },
            yoyo: false,
            duration: this.spinAnimationDuration * 0.75,
            onStart: () => {
                this.stopped = true;
            },
            onUpdate: () => {
                this.getCells().forEach((cell) => {
                    // Position
                    this.bendReelRun(cell);
                });
            },
            onComplete: () => {
                this.scene.soundManager.play(ResourcesDispatcher.SOUNDS.SOUND_REELS_STOP);

                if (!this.gameLogicVariableManager.getTurbo()) {

                    for(let i=0; i<this.lastCellIndex; i++){
                        const currentCell = this.getCell(i)
                        if(!currentCell) continue;

                        const memo = currentCell.getMemo();
                    }

                    // Scatter sound
                    if (this.gameDataManager.getScatterInfo().length > 0) {

                        const scatter: boolean = (this.gameDataManager.getScatterInfo().filter((info:any) => info.reelIndex === this.index).length !== 0);
                        const minNumScatter: number = (this.gameLogicVariableManager.getCurrentGameMode() === ResourcesDispatcher.GAME_CONSTANTS.GAME_MODE.FREEGAME ? 2 : 3);
                        const previousReelsWithScatter: number = this.gameDataManager.getScatterInfo().filter((info : any) => info.reelIndex < this.index).length;
                        const residualScattersToWin: number = minNumScatter - previousReelsWithScatter - (scatter ? 1 : 0); // -1 because this reeel contains a scatter
                        const residualReels: number =  this.numOfReels - 1 - this.index;

                        if (
                            (scatter && !this.mustStop && residualScattersToWin <= 0) ||                // CONDITION 1: scatter in reel, no forced stop, freegame already won
                            (scatter && !this.mustStop && residualScattersToWin <= residualReels) ||    // CONDITION 2: scatter in reel, no forced stop, freegame can still be won
                            (this.mustStop && residualReels === 0 && residualScattersToWin === 0)       // CONDITION 3: forced stop, last reel and freegame already won
                        ) {
                            //TODO Mettere questa riga e sostituire con this.soundscatterinreel con sound
                            this.scene.soundManager.getSoundGame().play(this.soundScatterInReel.key, { loop: this.soundScatterInReel.loop, volume: this.soundScatterInReel.volume });
                        }
                    }
                }

                // Turbo on(low volume) or forced stop
                if (this.gameLogicVariableManager.getTurbo() || this.mustStop) {
                    // TODO: add stop sound
                }

                this.bounceTween2 = this.scene.tweens.add({
                    targets: this.spinProgressValue,
                    ease: "Power0",
                    value: { from: this.cellSize.height * 0.75, to: 0 },
                    yoyo: false,
                    duration: this.spinAnimationDuration * 6,     
                    //TODO implementare ONSTART
                    onStart: () => {
                    },
                    onUpdate: () => {
                        this.getCells().forEach((cell) => {
                            // Position
                            this.bendReelRun(cell);
                        });
                    },
                    onComplete: () => {
                        this.getCells().forEach((cell) => {
                            cell.checkLayer();
                        });

                        this.scene.time.addEvent({
                            delay: 150,
                            callback: () => {
                                this.scene.gameArea.notifySpinCompleted(this.index);
                            },
                        });

                        this.manageSuspense();
                    }
                });
            }
        });
    }
}
